// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"PersonalDetailsInput_cardTitle__Pljdp"};